// extracted by mini-css-extract-plugin
module.exports = {"ReplyButton":"ms_a bag_tu bag_iv bag_uh bag_i bag_j bag_q bag_sr bag_en bag_pm bag_pn bag_cx","ReplyButton__icon":"ms_b bag_pi"};